import Vue from 'vue';
import permissionPlugin from '@/project/plugins/permission.plugin';

// Plugins
Vue.use(permissionPlugin);
